import React from "react";
import { Card, CardHeader, CardTitle } from "./ui/card";
import { Button } from "./ui/button";
import { useParams, useNavigate } from "react-router";
import _ from "lodash";
import useProjectActions from "../hooks/useProjectActions";
import { deleteFileFromURI } from "../helpers/storageHelpers";
import Modal from "../Modal";
import useFirebaseProject from "../hooks/useFirebaseProject";
import { correctlySizedPhoto } from "../helpers/photoHelpers";

const PhotoDeletePage = () => {
  const { id, index } = useParams();
  const navigate = useNavigate();
  const project = useFirebaseProject(id!);

  const { editProject } = useProjectActions();

  const actions = () => (
    <React.Fragment>
      <Button
        variant="destructive"
        onClick={() => {
          const newProject = _.cloneDeep(project)!;
          newProject.photos!.splice(Number(index), 1);
          const photo = project!.photos![Number(index)];
          if (photo?.photo) {
            deleteFileFromURI(photo.photo);
          }
          if (photo?.photo256?.uri) {
            deleteFileFromURI(photo.photo256.uri);
          }
          if (photo?.photo1024?.uri) {
            deleteFileFromURI(photo.photo1024.uri);
          }
          editProject(project!.id!, newProject);
        }}
      >
        Delete
      </Button>
      <Button variant="outline" onClick={() => navigate(-1)}>Cancel</Button>
    </React.Fragment>
  );

  const renderContent = () => {
    if (!project || !project.photos?.[Number(index)]) {
      return <div>Loading...</div>;
    }

    return (
      <React.Fragment>
        <Card>
          <img src={correctlySizedPhoto(project.photos![Number(index)]).uri} alt="" />
          <CardHeader><CardTitle>Type:{project.photos![Number(index)].type}</CardTitle></CardHeader>
        </Card>
      </React.Fragment>
    );
  };

  return (
    <Modal
      title="Delete Photo?"
      content={renderContent()}
      actions={actions()}
      onDismiss={() => navigate(-1)}
    />
  );
};

export default PhotoDeletePage;
